import { isDefined } from '@freelancer/utils';
import type { EnterpriseObjectApi } from 'api-typings/users/users';
import type { EnterpriseModel } from './enterprises.model';

export function transformEnterprise(
  enterprise: EnterpriseObjectApi,
): EnterpriseModel {
  if (!isDefined(enterprise.is_test_enterprise)) {
    throw new ReferenceError(
      'Enterprise does not have `is_test_enterprise` attribute',
    );
  }
  if (!isDefined(enterprise.kyc_verified)) {
    throw new ReferenceError(
      'Enterprise does not have `kyc_verified` attribute',
    );
  }
  if (!isDefined(enterprise.date_created)) {
    throw new ReferenceError(
      'Enterprise does not have `date_created` attribute',
    );
  }

  return {
    id: enterprise.id,
    internalName: enterprise.internal_name,
    name: enterprise.name,
    isTestEnterprise: enterprise.is_test_enterprise,
    kycVerified: enterprise.kyc_verified,
    seoUrl: enterprise.seo_url,
    dateCreated: enterprise.date_created * 1000,
    membersCount: enterprise.members_count,
    description: enterprise.description,
    landingPageUrl: enterprise.landing_page_url,
    logoFileId: enterprise.logo_file_id,
    avatarFileId: enterprise.avatar_file_id,
  };
}
